import fetchAPI from "./fetchAPI"

export async function requestArticleLike(context, id, action, token) {
  const { articleLike } = await fetchAPI(
    `mutation($context: String!, $id: ID!, $action: LikeAction!, $token: String!) {
        articleLike(context: $context, id: $id, action: $action, token: $token) {
          status
          likes
        }
      }`,
    {
      variables: { context, id, action, token }
    },
    true
  )

  return articleLike
}

export async function fetchLikeCount(context, id) {
  const { fetchLikeCount } = await fetchAPI(
    `query($context: String!, $id: ID!) {
        fetchLikeCount(context: $context, id: $id) {
          status
          likes
        }
      }`,
    {
      variables: { context, id }
    }
  )
  return fetchLikeCount
}
